import React, { useEffect, useRef, useState, useContext } from "react"
import styled from "styled-components"
import gsap from "gsap"

import colors from "assets/styles/colors"
import text from "assets/styles/text"
import media from "assets/styles/media"
import BGGrid from "components/uIElements/BGGrid"

import Internet from "assets/images/homepage/Doge-Internet.svg"
import Mobile from "assets/images/homepage/Doge-Mobile.svg"
import Cloud from "assets/images/homepage/Doge-Cloud.svg"
import Crypto from "assets/images/homepage/Doge-Crypto.svg"
import { ScreenContext } from "components/Providers"

const Doge: React.FC = () => {
  const transitionRef = useRef<HTMLDivElement>(null)
  const transitionInnerRef = useRef(null)
  const [wrapper, setWrapper] = useState<HTMLElement | null>(null)
  const [mainContent, setMainContent] = useState<HTMLElement | null>(null)
  const { fullWidth, desktop, tablet, mobile } = useContext(ScreenContext)

  useEffect(() => {
    if (!mobile && !tablet) {
      const tl = gsap.timeline({
        scrollTrigger: {
          scroller: "#___gatsby",
          trigger: wrapper,
          scrub: true,
          start: "top top",
          end: "bottom bottom",
        },
      })

      tl.to(".display-text0", {
        scale: 1,
        duration: 0.5,
        x: "-4.2vw",
      }, 0)
      .to(".display-text0", {
          scale: 1.5,
          duration: 0.5,
          x: "-4.2vw",
        }, 0.5)
      .to(".display-text0", {
          scale: 1,
          duration: 0.5,
          x: "-4.2vw",
        }, 1)
      .to(".display-text1", {
          scale: 1,
          duration: 0.5,
        }, 0.75)
      .to(".display-text1", {
          scale: 1.5,
          duration: 0.5,
        }, 1.25)
      .to(".display-text1", {
          scale: 1,
          duration: 0.5,
        }, 1.75)
      .to(".display-text2", {
          scale: 1,
          duration: 0.5,
        }, 1.75)
      .to(".display-text2", {
          scale: 1.5,
          duration: 0.5,
        }, 2.25)
      .to(".display-text2", {
          scale: 1,
          duration: 0.5,
        }, 2.75)
      .to(".display-text3", {
          scale: 1,
          duration: 0.5,
        }, 2.5)
      .to(".display-text3", {
          scale: 1.5,
          duration: 0.5,
        }, 3)
      .to(".display-text3", {
          scale: 1,
          duration: 0.5,
        }, 3.5)
      .to(".display-text3", {
          scale: 1,
          duration: 0.5,
        }, 4)

      const tl2 = gsap.timeline({
        scrollTrigger: {
          scroller: "#___gatsby",
          trigger: transitionInnerRef.current,
          scrub: true,
          start: "top bottom-=200",
          end: "top top",
        },
      })

      tl2
        .to(
          transitionRef.current,
          {
            duration: 1,
            width: "100vw",
            right: "0vw",
          },
          0
        )
        .to(
          transitionInnerRef.current,
          {
            duration: 2,
            height: `200%`,
            top: "20vw",
          },
          0
        )
        .fromTo(
          transitionInnerRef.current,
          {
            background:
              "linear-gradient(180deg, rgba(25, 101, 254, 1) 0%, rgba(25, 101, 254, 1) 50%, rgba(25, 101, 254, 0) 100%)",
          },
          {
            duration: 1,
            background:
              "linear-gradient(180deg, rgba(25, 101, 254, 0) 0%, rgba(25, 101, 254, 1) 50%, rgba(25, 101, 254, 0) 100%)",
          },
          0
        )
        .fromTo(
          transitionInnerRef.current,
          {
            background:
              "linear-gradient(180deg, rgba(25, 101, 254, 0) 0%, rgba(25, 101, 254, 1) 50%, rgba(25, 101, 254, 0) 100%)",
          },
          {
            duration: 1,
            background:
              "linear-gradient(180deg, rgba(25, 101, 254, 1) 0%, rgba(25, 101, 254, 1) 50%, rgba(25, 101, 254, 1) 100%)",
          },
          1
        )
      return () => {
        tl.kill()
        tl2.kill()
      }
    } else {
      if (mainContent) {
        const tl1 = gsap.timeline({
          scrollTrigger: {
            scroller: "#___gatsby",
            trigger: mainContent,
            scrub: true,
            // markers: true,
            start: "top 80%",
            end: `bottom 100%`,
          },
        })

        tl1
          .to(
            ".display-text0",
            {
              scale: 1,
              duration: 40,
            },
            0
          )
          .to(
            ".display-text0",
            {
              scale: 1.5,
              duration: 40,
            },
            10
          )
          .to(
            ".display-text1",
            {
              scale: 1,
              duration: 40,
            },
            100
          )
          .to(
            ".display-text1",
            {
              scale: 1.5,
              duration: 40,
            },
            140
          )
          .to(
            ".display-text2",
            {
              scale: 1,
              duration: 40,
            },
            180
          )
          .to(
            ".display-text2",
            {
              scale: 1.5,
              duration: 40,
            },
            220
          )
          .to(
            ".display-text3",
            {
              scale: 1,
              duration: 40,
            },
            280
          )
          .to(
            ".display-text3",
            {
              scale: 1.5,
              duration: 40,
            },
            320
          )
          .to(".display-text3", { opacity: 1, duration: 140 }, 360)
          .to(
            transitionRef.current,
            {
              ease: "linear",
              y: 0,
              width: "100%",
              height: "200vh",
              duration: 60,
            },
            400
          )
          .to(
            transitionInnerRef.current,
            {
              ease: "linear",
              height: "100%",
              top: 0,
              width: "100%",
              duration: 60,
              background: colors.blue400,
            },
            400
          )
          .to(
            ".Doge__Blue-Grad",
            {
              y: "-=200vh",
              duration: 500,
              scaleY: 2,
            },
            0
          )

        return () => {
          tl1.kill()
        }
      }
    }
  }, [mobile, tablet, mainContent])

  const gridConfig = {
    sectionHeight: "100%",
    sectionRef: wrapper,
    animationClass: "doge",
    darkSection: true,
  }

  return (
    <Wrapper
      id="Doge"
      ref={ref => setWrapper(ref)}
      data-scroll
      data-scroll-section
      data-scroll-repeat
    >
      <BGGrid lineConfig={gridConfig} />
      <MainContent ref={ref => setMainContent(ref)}>
        <StickyWrapper id="Home-Doge__Sticky0">
          <Image1
            data-scroll
            data-scroll-sticky
            data-scroll-target="#Home-Doge__Sticky0"
            src={Internet}
            alt={"internet"}
          />
        </StickyWrapper>
        <StickyWrapper id="Home-Doge__Sticky1">
          <Image2
            data-scroll
            data-scroll-sticky
            data-scroll-target="#Home-Doge__Sticky1"
            src={Mobile}
            alt={"mobile"}
          />
        </StickyWrapper>
        <StickyWrapper id="Home-Doge__Sticky2">
          <Image3
            data-scroll
            data-scroll-sticky
            data-scroll-target="#Home-Doge__Sticky2"
            src={Cloud}
            alt={"cloud"}
          />
        </StickyWrapper>
        <StickyWrapper id="Home-Doge__Sticky3">
          <Image4
            data-scroll
            data-scroll-sticky
            data-scroll-target="#Home-Doge__Sticky3"
            src={Crypto}
            alt={"crypto"}
          />
        </StickyWrapper>

        <TextWrapper>
          <BlueGradient1
            className="Doge__Blue-Grad"
            data-scroll
            data-scroll-speed="4"
          />
          <BlueGradient2
            className="Doge__Blue-Grad"
            data-scroll
            data-scroll-speed="4"
          />
          <BlueGradient3
            className="Doge__Blue-Grad"
            data-scroll
            data-scroll-speed="3"
          />
          <BlueGradient4
            className="Doge__Blue-Grad"
            data-scroll
            data-scroll-speed="4"
          />
          <BlueGradient5
            className="Doge__Blue-Grad"
            data-scroll
            data-scroll-speed="3"
          />
          <TransitionSticky id="Home-Doge__StickyT" ref={transitionRef}>
            <BlueTransition
              ref={transitionInnerRef}
              data-scroll
              data-scroll-sticky
              data-scroll-target="#Home-Doge__StickyT"
            />
          </TransitionSticky>

          <DisplayText className="display-text display-text0" data-scroll>
            internet
          </DisplayText>
          <DisplayText className="display-text display-text1" data-scroll>
            mobile
          </DisplayText>
          <DisplayText className="display-text display-text2" data-scroll>
            cloud
          </DisplayText>
          <DisplayText className="display-text display-text3" data-scroll>
            crypto
          </DisplayText>
        </TextWrapper>
      </MainContent>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background: ${colors.black800};
  padding: 71.15vw 0 45vw;
  position: relative;
  margin-top: -50vw; // sowwy UwU
  z-index: -1;
  ${media.tablet} {
    margin-top: 0;
    height: 600vh;
    padding: 0;
    overflow: initial;
  }
  ${media.mobile} {
    margin-top: 0;
    height: 600vh;
    margin-bottom: -50vh;
    overflow: hidden;
    padding: 0;
    overflow: initial;
  }
`

const MainContent = styled.div`
  ${media.tablet} {
    height: 100%;
  }
  ${media.mobile} {
    height: 100%;
  }
`

const StickyWrapper = styled.div`
  width: 30.56vw;
  height: 100%;
  position: absolute;
  padding-top: calc(50vh - 9.65vw);
  top: 51.47vw;
  left: 9.72vw;
  &:nth-of-type(2) {
    top: 108.58vw;
  }
  &:nth-of-type(3) {
    top: 164.14vw;
  }
  &:nth-of-type(4) {
    top: 219.7vw;
  }
  ${media.tablet} {
    height: 500vh;

    top: 0;
    left: calc(50% - 46vw);
    width: 92vw;
    padding-top: 67.77vw;
    &:nth-of-type(2) {
      padding-top: 62.99vw;
      top: 100vh;
      height: 400vh;
    }
    &:nth-of-type(3) {
      padding-top: 66.7vw;
      top: 200vh;
      height: 300vh;
    }
    &:nth-of-type(4) {
      padding-top: 69.14vw;
      top: 300vh;
      height: 200vh;
    }
  }
  ${media.mobile} {
    height: 500vh;
    top: 0;
    left: calc(50% - 46vw);
    width: 92vw;
    padding-top: 374px;

    &:nth-of-type(2) {
      top: 100vh;
      height: 400vh;
    }
    &:nth-of-type(3) {
      top: 200vh;
      height: 300vh;
    }
    &:nth-of-type(4) {
      top: 300vh;
      height: 200vh;
    }
  }
`

const Image = styled.img`
  height: 19.31vw;
  width: 100%;
  display: block;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  /* margin-bottom: 41.18vw; */
  ${media.tablet} {
    height: 56.27vw;
  }
  ${media.mobile} {
    height: 56.27vw;
  }
`

const Image1 = styled(Image)`
  width: 17.36vw;
  height: auto;
  ${media.tablet} {
    width: 35.35vw;
    height: auto;
  }
  ${media.mobile} {
    width: 56.27vw;
  }
`

const Image2 = styled(Image)`
  width: 13.54vw;
  ${media.tablet} {
    width: 31.641vw;
    height: 31.641vw;
  }
  ${media.mobile} {
    width: 40vw;
  }
`

const Image3 = styled(Image)`
  width: 30.49vw;
  ${media.tablet} {
    width: 38.184vw;
    height: auto;
  }
  ${media.mobile} {
    width: 56.27vw;
  }
`

const Image4 = styled(Image)`
  width: 17.36vw;
  ${media.tablet} {
    width: 34.18vw;
    height: auto;
  }
  ${media.mobile} {
    width: 56.27vw;
  }
`

const TextWrapper = styled.div`
  width: 36.8vw;

  margin-left: 56.6vw;
  text-align: center;
  padding-top: 8vw;
  ${media.tablet} {
    width: 100%;
    margin-left: 0;
    /* padding-top: 63.73vw; */
    padding-top: 0;
  }
  ${media.mobile} {
    width: 100%;
    margin-left: 0;
    padding-top: 63.73vw;
  }
`

const BlueGradient = styled.div`
  background: ${colors.lightBlueGradient};
  width: 9.5vw;
  position: absolute;
  z-index: 0;
  /* margin-left: 2.2vw; */
  ${media.tablet} {
    width: 18.555vw;
  }
  ${media.mobile} {
    width: 18.4vw;
  }
`

const BlueGradient1 = styled(BlueGradient)`
  height: 18.1vw;
  left: 22.3vw;
  top: 100.56vw;

  ${media.tablet} {
    left: 23.438vw;
    height: 40vw;
    top: 100vh;
    width: 18.555vw;
  }
  ${media.mobile} {
    width: 18.667vw;
    left: 22.667vw;
    height: 40vw;
    top: 100vh;
  }
`

const BlueGradient2 = styled(BlueGradient)`
  height: 16.67vw;
  right: 12vw;
  top: 121.54vw;
  ${media.tablet} {
    right: auto;
    left: 79.102vw;
    top: 200vh;
    width: 18.555vw;
  }
  ${media.mobile} {
    width: 18.667vw;
    right: auto;
    left: 78.667vw;
    top: 200vh;
  }
`

const BlueGradient3 = styled(BlueGradient)`
  left: 12.85vw;
  height: 20.83vw;
  top: 156.26vw;

  ${media.tablet} {
    left: 4.883vw;
    top: 300vh;
    width: 18.555vw;
  }
  ${media.mobile} {
    width: 18.667vw;
    left: 4vw;
    top: 300vh;
  }
`

const BlueGradient4 = styled(BlueGradient)`
  height: 8.33vw;
  right: 12vw;
  top: 170.15vw;
  ${media.tablet} {
    left: 60.547vw;
    right: auto;
    top: 400vh;
    width: 18.555vw;
  }
  ${media.mobile} {
    width: 18.667vw;
    left: 60vw;
    right: auto;
    top: 400vh;
  }
`

const BlueGradient5 = styled(BlueGradient)`
  height: 22.22vw;
  left: 31.6vw;
  top: 206.26vw;
  ${media.tablet} {
    left: 41.992vw;
    top: 500vh;
    width: 18.555vw;
  }
  ${media.mobile} {
    width: 18.667vw;
    left: 41.333vw;
    top: 500vh;
  }
`

const TransitionSticky = styled.div`
  position: absolute;
  width: 9.5vw;
  height: 100vh;
  right: 5.42vw;
  top: calc(275vw - 80vh);
  padding-top: 80vh;
  z-index: 3;
  ${media.tablet} {
    top: 400vh;
    width: 18.4vw;
    right: 0;
  }
  ${media.mobile} {
    top: 400vh;
    width: 18.4vw;
    right: 0;
  }
`

const BlueTransition = styled(BlueGradient)`
  height: 13vw;
  width: 100%;
  background: linear-gradient(180deg, #1965fe 0%, rgba(25, 101, 254, 0) 100%);
  ${media.tablet} {
    width: 18.4vw;
    height: 21.33vw;
  }
  ${media.mobile} {
    width: 18.4vw;
    height: 21.33vw;
  }
`

const DisplayText = styled.h2`
  ${text.desktop.d2}
  color:  ${colors.white};
  margin-bottom: 41.18vw;
  transform: scale(1.5);
  will-change: transform;
  ${media.tablet} {
    position: absolute;
    ${text.mobile.d3};

    width: 100%;

    text-align: center;
    :nth-of-type(1) {
      top: 63.73vw;
    }

    :nth-of-type(2) {
      top: calc(100vh + 63.73vw);
    }
    :nth-of-type(3) {
      top: calc(200vh + 63.73vw);
    }
    :nth-of-type(4) {
      top: calc(300vh + 63.73vw);
    }
  }

  ${media.mobile} {
    position: absolute;
    ${text.mobile.d3};

    width: 100%;

    text-align: center;
    :nth-of-type(1) {
      top: 63.73vw;
    }

    :nth-of-type(2) {
      top: calc(100vh + 63.73vw);
    }
    :nth-of-type(3) {
      top: calc(200vh + 63.73vw);
    }
    :nth-of-type(4) {
      top: calc(300vh + 63.73vw);
    }
  }
`

export default Doge
